<template>
	<div class="text">
    <div style="text-align: center; font-size: 12px; color: #666666">
      版本更新时间：2025年2月10日
    </div>
    <div style="text-align: center; font-size: 12px; color: #666666">
      协议生效时间：2025年2月10日
    </div>
    <p>
      {{ name }}(其中关联公司包括但不限于{{
        company
      }}，下称“我们”）和服务使用人（下称“您”）就您按照本协议规定及我们不时发布的操作规则使用基于互联网的充值服务（下称“充值服务”)所签订的协议。
    </p>
    <p>
      为获得充值服务，请您认真阅读并充分知悉、理解本平台的各项规则及要求，以及国家关于该类互联网信息服务的法律法规等。如果您对本协议的任何条款表示异议，您可以选择不使用充值服务；如您自主选择按照页面提示完成充值程序，即视为您将同意遵守本协议全部条款，以及我们后续对本协议随时所作的任何修改，并完全服从于我们的统一管理。本协议已对与您的权益具有或可能具有重大关系的条款，请您注意。
    </p>
    <p>
      您须确认自己具有完全民事行为能力，已年满18周岁，或已年满16周岁且依靠自己的劳动收入作为主要生活来源，有权且有能力同意本条款及相关协议的全部内容。本平台不鼓励未成年人使用相关服务，未成年人请委托监护人操作或在监护人明示同意下操作，否则不得使用本平台充值服务。请未成年人用户监护人切实履行其监护义务。对于未成年用户使用充值服务过程中的行为，以及因其使用充值服务而产生的一切后果本平台不承担任何责任。
    </p>
    <p>
      第1条
      VIP权限是我们向您提供的仅限用于在本平台上进行相关使用的服务，您可充值开通不同权限等级的VIP。由于服务权限的特殊属性，致使充值服务原则上不适用《消费者权益保护法》中有关反悔权及七日无理由退货等条款的约束。您一旦充值成功，本平台的充值服务即已提供完毕，本平台不提供任何退还或逆向兑换人民币服务。您用以充值的账号由您独立维护、使用并独立承担全部责任，本平台不会、也不可能参与该账号的使用等任何活动。
    </p>
    <p>
      第2条
      您务必根据自身实际需求充值相应等级的VIP权限，您确认了解并接受在充值VIP权限时页面所显示的VIP价格及服务。
    </p>
    <p>
      第3条
      您可按照本平台充值页面上的相应提示完成充值程序，当我们通过第三方支付平台确认收到您为开通VIP权限所支付的款项后，则视为您已完成充值相应等级VIP的交易。充值成功后，充值所增加的账号内VIP使用次数可由您在本平台上自由使用。
    </p>
    <p>
      第4条
      您的用户账户中显示的VIP使用次数并不构成现实世界的余额或反映任何存储值，而是构成对本平台服务中的许可范围的一种衡量。您无法将VIP使用次数兑换为真实货币（包括但不限于人民币等）。
    </p>
    <p>
      第5条
      本平台有权根据业务发展规划、国家法律法规或监管的要求，调整、修改、完善、优化、升级或中止、取消本充值功能，您不得因此追究平台的违约或侵权责任。本平台开展前述行动时，将在本平台公布通知，并自公布之日起自动生效，而无需另行单独通知您，也不就该等行动给您造成的任何损失承担任何责任。
    </p>
    <p>
      第6条
      在使用充值服务时，您务必仔细确认自己的账号并仔细选择相关操作选项。若因为您自身输入账号错误、操作不当或不了解充值计费方式等因素造成充错账号、错选充值种类等情形而损害自身权益的，本平台将不会作出任何补偿或赔偿。
    </p>
    <p>
      第7条
      您只能通过平台认可的渠道、通过自己的支付账户为自己的账号进行充值，而不得通过其他渠道进行充值，也不得通过他人的支付账户或其他支付手段进行充值。否则即属于违规。违规的充值将不被平台认可，从而面临充值额被扣除、账号被限制或禁止使用部分或全部功能乃至永久封号等处理。此外，违规的充值行为还可能引发盗号、诈骗等风险。
    </p>
    <p>
      第8条
      若您以非法、欺诈或利用本平台漏洞的方式，或使用非本平台所指定的充值方式进行充值，本平台不保证该充值顺利或者正确完成。若因此造成您权益受损，本平台不会作出任何补偿或赔偿，同时保留随时终止您本平台账号资格及使用各项充值服务的权利。
    </p>
    <p>
      第9条
      您不得通过本平台充值进行任何违法犯罪活动，否则本平台有权终止服务，情节严重的，依法移交司法机关
    </p>
    <p>
      第10条
      如果本平台发现因系统故障或其他任何原因导致的充值处理错误，无论有利于本平台还是有利于您，本平台都有权在以合理方式通知您后纠正该错误。如果该错误导致您实际收到的VIP使用次数少于您应获得的VIP使用次数，则本平台在确认该处理错误后会尽快将差额补足至您的本平台账户中。如果该错误导致您实际收到的VIP使用次数多于您应获得的VIP使用次数，则无论错误的性质和原因如何，本平台有权从您的本平台账户中直接扣除差额。如该等充值您已经使用的，则平台有权在您未来充值获得的VIP使用次数中进行扣除。
    </p>
    <p>
      第11条
      您可随时在本平台上查看您的VIP使用次数余额情况及相关到期时间。如您对该记录有异议，应立即向本平台提出，本平台核对后确有错误的，将予以更正；否则您同意将本平台上的开通记录作为VIP服务到期的唯一有效依据。
    </p>
    <p>
      第12条
      本平台有权基于交易安全等方面的考虑不时设定涉及交易的相关事项，包括但不限于交易限额、交易次数等。本平台的前述设定可能对您的交易造成一定不便，您对此没有异议。
    </p>
    <p>
      第13条
      各充值方式对应的第三方渠道商可能会按其标准制定相关充值渠道手续费用（可能会在充值操作页面或渠道商其他页面上提示），并在充值VIP使用次数时收取。请您务必注意各充值方式的渠道商服务手续费，并按自身需求选取充值方式。在任何情况下，对于您充值VIP使用次数时涉及由第三方提供相关服务的责任由该第三方承担，本平台不承担该等责任。您理解并同意充值后您通过第三方平台申请退款时，为验证充值/退款的真实性，第三方会向平台申请调取您的历史充值金额、历史退款金额、账号注册时长、您在本平台的登陆状态、申请退款订单购买的产品消耗程度以及您是否同意提供消费数据。届时平台会向第三方提供上述信息以便判断是否可退款。
    </p>
    <p>
      第14条
      您应确保您进行充值绑定的支付账户开户人/持有人，可合法、有效使用该账户且未侵犯任何第三方合法权益，否则因此造成账户实际所有人损失的，您应单独负责解决由此产生的纠纷并承担全部法律责任。您应确保用于充值VIP使用次数的资金为个人合法财产，您利用该资金充值VIP使用次数不存在任何违法犯罪目的；如您用于充值VIP使用次数的资金被公安机关、检察院、法院等国家机关认定为非法资金（包括但不限于非法集资、职务侵占、挪用公款或贪污受贿等所得资金），并导致该等国家机关对我们的银行账户资金采取了冻结、强制执行等措施，您应赔偿我们因此而遭受的全部损失（包括但不限于被强制执行的全部金额及相应利息、为维权而支付的公证费、诉讼费、保全费、律师费、差旅费及鉴定费等）。同时，本平台发现（包括但不限于主动发现、收到第三方投诉或权力机关通知等情形）存在上述事由，有权单方决定限制您使用全部或部分充值“VIP使用次数”、暂停或终止向您提供充值服务或对您的帐号采取进一步管理措施；如因此给平台造成损失的，您应予以全额赔偿，同时，平台有权保存相关信息，并向相关执法/司法机构、主管部门报告。
    </p>
    <p>
      第15条
      因您自身的原因导致本平台无法提供VIP使用次数充值服务或提供VIP使用次数充值服务时发生任何错误而产生的任何损失或责任，由您自行负责，本平台不承担责任，包括但不限于：
    </p>
    <p>
      （1）您未按照《用户服务协议》或本协议或本平台不时公布的任何规则进行操作；
    </p>
    <p>（2）因您的设备中本平台应用程序失效、丢失、被封停；</p>
    <p>
      （3）因您绑定的第三方支付机构账户的原因导致的损失或责任，包括您使用未经认证的第三方支付账户或使用非您本人的第三方支付账户，您的第三方支付账户被冻结、查封等；
    </p>
    <p>（4）您将密码告知他人导致的财产损失；</p>
    <p>（5）因您个人的故意或重大过失或本协议之外的第三方所造成的您财产损失。</p>
    <p>
      第16条
      本平台系统因下列状况无法正常运作，使您无法使用各项服务或任何虚拟财产丢失时，本平台不承担损害赔偿责任，该状况包括但不限于：
    </p>
    <p>（1）在本平台公告之系统停机维护、升级、调整期间；</p>
    <p>（2）电信通讯或设备出现故障不能进行数据传输的；</p>
    <p>
      （3）因台风、地震、海啸、洪水、停电、战争、恐怖袭击、政府管制等不可抗力之因素，造成本平台系统障碍不能执行业务的；
    </p>
    <p>
      （4）由于黑客攻击、电信部门技术调整或故障、网站升级、相关第三方的问题等原因而造成的服务中断或者延迟。
    </p>
    <p>
      第17条
      在任何情况下，本平台均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害承担责任。本平台对您承担的全部责任，无论因何原因或何种行为方式，始终不超过您因使用本平台提供的充值服务而支付的费用。
    </p>
    <p>
      第18条
      如发生下列任何一种情形，本平台有权随时中断或终止向您提供本协议项下的网络服务而无需通知您，且无需承担因充值服务中断或终止而给您或第三方造成的损失的任何责任：
    </p>
    <p>（1）您提供的个人资料不真实；</p>
    <p>（2）您违反本协议中规定的充值规则及保证内容；</p>
    <p>（3）您违反《用户服务协议》或其他本平台对用户的管理规定；</p>
    <p>（4）您以营利、经营等非个人使用目的充值、使用VIP使用次数。</p>
    <p>
      除前款所述情形外，本平台同时保留在不事先通知您的情况下随时中断或终止部分或全部网络充值服务的权利，对于充值服务的中断或终止而造成的任何损失，本平台无需对您或任何第三方承担任何责任。
    </p>
    <p>
      第19条
      如果您违规使用非本人手机应用商店代充值，或者通过其它非本平台认可的渠道非法充值VIP使用次数，则本平台有权冻结该账户，并进行相应惩罚，严重者可以进行封号处理。
    </p>
    <p>
      第20条
      您在使用本平台时，如出现违反国家法律法规、《用户服务协议》约定、本协议约定或其他本平台公布的协议或对用户的管理规定的情形，本平台有权暂时或永久封禁您的账号，且有权扣除本平台赠送/奖励的VIP使用次数(如有)。账号封禁后至解禁（如有）前，您账户上的剩余VIP使用次数将被暂时冻结或全部扣除，不可继续用于消费本平台上的虚拟产品或服务，同时不予返还您充值VIP使用次数时的现金价值。
    </p>
    <p>
      第21条
      本平台保留修改或增补本协议内容的权利。本协议的修改文本将公告于本平台或以其他本平台认为可行的方式公告。修改文本一旦公布则立即生效。若您在本协议内容发生修订后，继续使用本服务的，则视为您同意最新修订的协议内容；否则您须立即停止使用充值服务或本平台。
    </p>
    <p>
      第22条
      为实现业务目的、保障业务安全，平台有权独立设定本功能开通的要求和开通的对象、范围，有权采用技术手段审核您使用本功能的行为，以确保您的使用不违反法律法规及本条款、相关协议之约定。此外，平台的前述审核行为并不代表平台对您使用本功能之行为的合法性进行认可或担保，对您的行为所产生的一切责任和后果仍由您独立承担。
    </p>
    <p>
      第23条您理解并同意，平台有权依合理判断对违反有关法律法规或本条款约定的行为进行处罚，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，您应独自承担由此而产生的一切法律责任
    </p>
    <p>
      第24条
      您理解并同意，因您违反本条款或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，您应当独立承担责任；若平台因此遭受损失的，您也应当一并赔偿平台的损失。
    </p>
    <p>
      第25条
      您理解并同意：若由于以下情形导致的功能中断或受阻，平台并不承担任何法律责任：
    </p>
    <p>（1）受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；</p>
    <p>（2）您的电脑软件、系统、硬件和通信线路出现故障；</p>
    <p>（3）您操作不当；</p>
    <p>（4）您通过非平台授权的方式使用本功能；</p>
    <p>（5）其他平台无法控制或合理预见的情形。</p>
    <p>
      第26条
      本协议部分内容被有管辖权的法院认定为违法或无效的，不因此影响其他内容的效力。本协议未涉及的问题参见国家有关法律法规，当本协议与国家法律法规冲突时，以国家法律法规为准。
    </p>
  </div>
</template>
<script>
export default {
  name: "agreement",
  data() {
    return {
        name: '消考实操模拟软件',
        company: '上海杂鱼科技有限公司'
    };
  }
};
</script>
<style>
	.text {
		padding: 15px;
		font-size: 14px;
		color: #333;
        width: 100%;
        box-sizing: border-box;
	}

	.text p {
		line-height: 1.6;
        word-wrap:break-word;
    word-break:break-all;
	}

	.text .head {
		font-weight: 500;
	}

	.text .space2 {
		text-indent: 2em;
	}

	.text .space4 {
		text-indent: 4em;
	}
</style>
